// A3.26 — Ogohlantirish yuborish adapter. Module-local. Ogohlantirish durable
// saqlanadi + push (FCM/WebPush) orqali foydalanuvchiga yetkaziladi (yadro-chat
// TEGILMAYDI). Tarix ko'riladi.
import { api } from '@/lib/api'

export interface UserWarning {
  id: number
  admin_id?: number | null
  sender?: string | null // admin username
  message: string
  created_at: number
}

export async function fetchUserWarnings(userId: number, limit = 100): Promise<UserWarning[]> {
  const r = await api.get<{ items?: UserWarning[] }>(`/admin/users/${userId}/warnings`, { query: { limit } })
  return r.items ?? []
}

export async function sendUserWarning(userId: number, message: string): Promise<number> {
  const r = await api.post<{ id: number }>(`/admin/users/${userId}/warn`, { message })
  return r.id
}
